export default function languageSwitcher() {

    document.addEventListener('click', (e) => {
        const button = document.querySelector('.js-language-switcher');

        if (e.target.closest('.js-language-switcher')) {
            button.classList.toggle('active');
            button.closest('.custom-language-switcher').classList.toggle('active');
        } else {
            button.classList.contains('active') && button.classList.remove('active');
            button.closest('.custom-language-switcher').classList.contains('active') && button.closest('.custom-language-switcher').classList.remove('active');
        }
    });

    document.addEventListener('click', (e) => {
        const button = document.querySelector('.js-language-switcher-mobile');

        if (e.target.closest('.js-language-switcher-mobile')) {
            button.classList.toggle('active');
            button.closest('.custom-language-switcher-mobile').classList.toggle('active');
        } else {
            button.classList.contains('active') && button.classList.remove('active');
            button.closest('.custom-language-switcher-mobile').classList.contains('active') && button.closest('.custom-language-switcher-mobile').classList.remove('active');
        }
    });

}